import React, { useState } from 'react';
import { Users, NotebookPen, ShieldCheck, HeartHandshake, Ticket, CheckCircle, ChevronRight, CircleDollarSign, Music, BarChart3 } from 'lucide-react';

export const DashboardShowcase = () => {
  const [activeTab, setActiveTab] = useState('members');

  const tabs = [
    { id: 'members', label: 'Personas', icon: Users },
    { id: 'formation', label: 'Formación', icon: NotebookPen },
    { id: 'finances', label: 'Finanzas', icon: CircleDollarSign },
    { id: 'worship', label: 'Alabanza', icon: Music },
    { id: 'groups', label: 'Grupos', icon: ShieldCheck },
    { id: 'leadership', label: 'Liderazgo', icon: BarChart3 },
    { id: 'counseling', label: 'Consejería', icon: HeartHandshake },
    { id: 'tickets', label: 'Tickets', icon: Ticket },
  ];

  const renderTab = () => {
    switch (activeTab) {
      case 'members':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100 dark:border-slate-800 pb-4">
              <div>
                <h3 className="text-2xl font-black text-slate-900 dark:text-white">Directorio de Membresía</h3>
                <p className="text-xs font-medium text-slate-500">Fichas de congregantes, datos de contacto y vinculación a procesos.</p>
              </div>
              <span className="px-3.5 py-1.5 bg-indigo-50 dark:bg-indigo-950 text-indigo-600 dark:text-indigo-300 rounded-full text-xs font-black uppercase tracking-wider w-fit">Miembros Activos</span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr className="text-[10px] font-black uppercase tracking-widest text-slate-400 border-b border-slate-100 dark:border-slate-800">
                    <th className="py-3 px-4">Nombre</th>
                    <th className="py-3 px-4">Grupo</th>
                    <th className="py-3 px-4">Avance</th>
                    <th className="py-3 px-4">Estado</th>
                  </tr>
                </thead>
                <tbody className="text-xs font-bold divide-y divide-slate-100 dark:divide-slate-800 text-slate-700 dark:text-slate-300">
                  <tr>
                    <td className="py-3.5 px-4 font-black">María López García</td>
                    <td className="py-3.5 px-4 text-pink-600">Red Femenina</td>
                    <td className="py-3.5 px-4">Módulo 2</td>
                    <td className="py-3.5 px-4"><span className="px-2.5 py-1 bg-emerald-100 dark:bg-emerald-950 text-emerald-700 dark:text-emerald-300 rounded-lg text-[10px]">Activa</span></td>
                  </tr>
                  <tr>
                    <td className="py-3.5 px-4 font-black">Carlos Mendoza</td>
                    <td className="py-3.5 px-4">Red Masculina</td>
                    <td className="py-3.5 px-4">Adiestramiento</td>
                    <td className="py-3.5 px-4"><span className="px-2.5 py-1 bg-emerald-100 dark:bg-emerald-950 text-emerald-700 dark:text-emerald-300 rounded-lg text-[10px]">Activo</span></td>
                  </tr>
                  <tr>
                    <td className="py-3.5 px-4 font-black">Ana Ramírez</td>
                    <td className="py-3.5 px-4 text-indigo-600">Servidores</td>
                    <td className="py-3.5 px-4">Graduada</td>
                    <td className="py-3.5 px-4"><span className="px-2.5 py-1 bg-indigo-100 dark:bg-indigo-950 text-indigo-700 dark:text-indigo-300 rounded-lg text-[10px]">Líder</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      case 'formation':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Formación y Seguimiento</h3>
              <p className="text-xs font-medium text-slate-500">Escuelas bíblicas, inscripción de estudiantes y registro de lecciones.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { stage: 'Inicial', title: 'Fundamentos de la Fe', students: '45', color: 'indigo' },
                { stage: 'Intermedio', title: 'Módulos de Crecimiento', students: '62', color: 'violet' },
                { stage: 'Avanzado', title: 'Capacitación de Liderazgo', students: '28', color: 'emerald' },
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-50 dark:bg-slate-950 p-5 rounded-2xl border border-slate-200 dark:border-slate-800 space-y-2">
                  <span className={`text-[10px] font-black uppercase tracking-widest text-${item.color}-600`}>Etapa {item.stage}</span>
                  <h4 className="font-black text-slate-900 dark:text-white text-base">{item.title}</h4>
                  <div className="pt-2 flex items-center justify-between text-xs font-black">
                    <span className="text-slate-400">Cohorte Activa</span>
                    <span className={`text-${item.color}-600`}>{item.students} Estudiantes</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      case 'finances':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Control Financiero</h3>
              <p className="text-xs font-medium text-slate-500">Diezmos, ofrendas, proyectos y reportes en PDF.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-5 rounded-2xl bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-900 space-y-2">
                <span className="text-[10px] font-black uppercase tracking-widest text-emerald-700">Ingreso Registrado</span>
                <h4 className="font-black text-slate-900 dark:text-white text-lg">Diezmo Congregacional</h4>
                <p className="text-xs text-slate-500">Comprobante verificado.</p>
              </div>
              <div className="p-5 rounded-2xl bg-indigo-50 dark:bg-indigo-950/40 border border-indigo-200 dark:border-indigo-900 space-y-2">
                <span className="text-[10px] font-black uppercase tracking-widest text-indigo-700">Ofrendas Especiales</span>
                <h4 className="font-black text-slate-900 dark:text-white text-lg">Fondo de Infraestructura</h4>
                <p className="text-xs text-slate-500">Registro por concepto.</p>
              </div>
              <div className="p-5 rounded-2xl bg-violet-50 dark:bg-violet-950/40 border border-violet-200 dark:border-violet-900 space-y-2">
                <span className="text-[10px] font-black uppercase tracking-widest text-violet-700">Reportes</span>
                <h4 className="font-black text-slate-900 dark:text-white text-lg">Exportación PDF</h4>
                <p className="text-xs text-slate-500">Informes de auditoría.</p>
              </div>
            </div>
          </div>
        );
      case 'worship':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Ministerio de Alabanza</h3>
              <p className="text-xs font-medium text-slate-500">Coordinación de equipos, repertorios y cronogramas.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-5 rounded-2xl bg-indigo-50 dark:bg-indigo-950/40 border border-indigo-200 dark:border-indigo-900 space-y-2">
                <h4 className="font-black text-indigo-900 dark:text-indigo-200 text-sm">Cronograma de Servicios</h4>
                <p className="text-xs text-indigo-800 dark:text-indigo-300">Asignación de músicos, cantantes y directores.</p>
              </div>
              <div className="p-5 rounded-2xl bg-violet-50 dark:bg-violet-950/40 border border-violet-200 dark:border-violet-900 space-y-2">
                <h4 className="font-black text-violet-900 dark:text-violet-200 text-sm">Repertorio y Letras</h4>
                <p className="text-xs text-violet-800 dark:text-violet-300">Biblioteca musical con tonalidades y secuencias.</p>
              </div>
            </div>
          </div>
        );
      case 'groups':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Grupos y Células</h3>
              <p className="text-xs font-medium text-slate-500">Organización de reuniones comunitarias y toma de asistencia.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-5 rounded-2xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-900 space-y-2">
                <div className="flex justify-between items-center">
                  <h4 className="font-black text-amber-900 dark:text-amber-200 text-sm">Grupo Zona Norte</h4>
                  <span className="px-2.5 py-1 bg-amber-200 dark:bg-amber-900 text-amber-900 dark:text-amber-100 rounded-lg text-[10px] font-black">Semanal</span>
                </div>
                <p className="text-xs text-amber-800 dark:text-amber-300">Líder: Roberto Mendoza</p>
                <p className="text-xs text-slate-500">Promedio: 14 participantes</p>
              </div>
              <div className="p-5 rounded-2xl bg-indigo-50 dark:bg-indigo-950/40 border border-indigo-200 dark:border-indigo-900 space-y-2">
                <div className="flex justify-between items-center">
                  <h4 className="font-black text-indigo-900 dark:text-indigo-200 text-sm">Grupo Jóvenes</h4>
                  <span className="px-2.5 py-1 bg-indigo-200 dark:bg-indigo-900 text-indigo-900 dark:text-indigo-100 rounded-lg text-[10px] font-black">Semanal</span>
                </div>
                <p className="text-xs text-indigo-800 dark:text-indigo-300">Líder: Sofía Ramírez</p>
                <p className="text-xs text-slate-500">Promedio: 22 participantes</p>
              </div>
            </div>
          </div>
        );
      case 'leadership':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Redes de Liderazgo</h3>
              <p className="text-xs font-medium text-slate-500">Estructura de servidores, asignación de roles y supervisión.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { role: 'Pastores', count: '3', color: 'emerald' },
                { role: 'Líderes de Grupo', count: '12', color: 'indigo' },
                { role: 'Servidores Activos', count: '45', color: 'violet' },
              ].map((item, idx) => (
                <div key={idx} className="bg-slate-50 dark:bg-slate-950 p-5 rounded-2xl border border-slate-200 dark:border-slate-800 space-y-2 text-center">
                  <span className={`text-3xl font-black text-${item.color}-600`}>{item.count}</span>
                  <p className="text-xs font-bold text-slate-600 dark:text-slate-400">{item.role}</p>
                </div>
              ))}
            </div>
          </div>
        );
      case 'counseling':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Consejería Pastoral</h3>
              <p className="text-xs font-medium text-slate-500">Agenda reservada de citas y acompañamiento espiritual.</p>
            </div>
            <div className="p-6 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-slate-200 dark:border-slate-800 space-y-3">
              <div className="flex items-center gap-3 text-emerald-600 dark:text-emerald-400">
                <CheckCircle size={20} />
                <span className="text-xs font-bold">Gestión de Citas y Seguimiento Pastoral</span>
              </div>
              <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
                Programar reuniones de orientación, dar seguimiento a necesidades y organizar el cuidado espiritual con confidencialidad.
              </p>
            </div>
          </div>
        );
      case 'tickets':
        return (
          <div className="space-y-6 animate-in fade-in duration-500">
            <div className="border-b border-slate-100 dark:border-slate-800 pb-4">
              <h3 className="text-2xl font-black text-slate-900 dark:text-white">Tickets y Solicitudes</h3>
              <p className="text-xs font-medium text-slate-500">Requerimientos ministeriales y mantenimiento.</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="p-4 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-slate-200 dark:border-slate-800 flex items-center justify-between">
                <div>
                  <p className="text-xs font-black text-slate-900 dark:text-white">Mantenimiento Proyector</p>
                  <p className="text-[10px] text-slate-400">Ministerio de Medios</p>
                </div>
                <span className="px-2.5 py-1 bg-amber-100 text-amber-800 rounded-lg text-[10px] font-black">En Proceso</span>
              </div>
              <div className="p-4 bg-slate-50 dark:bg-slate-950 rounded-2xl border border-slate-200 dark:border-slate-800 flex items-center justify-between">
                <div>
                  <p className="text-xs font-black text-slate-900 dark:text-white">Insumos Escuela Infantil</p>
                  <p className="text-[10px] text-slate-400">Ministerio de Niños</p>
                </div>
                <span className="px-2.5 py-1 bg-emerald-100 text-emerald-800 rounded-lg text-[10px] font-black">Resuelto</span>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className="py-20 bg-slate-50 dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
            Conoce PastoreApp por dentro
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white tracking-tight">
            Diseñada para la realidad de tu congregación
          </h2>
          <p className="text-slate-600 dark:text-slate-400 text-base font-medium leading-relaxed">
            Explora los módulos de PastoreApp y descubre cómo se coordinan las áreas de tu iglesia.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-2">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-3 rounded-2xl text-xs font-black uppercase tracking-wider flex items-center gap-2 transition-all ${
                  isActive
                    ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-500/25 scale-[1.02]'
                    : 'bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 border border-slate-200 dark:border-slate-800'
                }`}
              >
                <Icon size={16} />
                <span className="hidden sm:inline">{tab.label}</span>
              </button>
            );
          })}
        </div>

        <div className="mt-10 bg-white dark:bg-slate-900 rounded-[2.5rem] border border-slate-200 dark:border-slate-800 p-6 sm:p-10 shadow-xl min-h-[420px] flex flex-col justify-between">
          {renderTab()}
          <div className="pt-6 mt-6 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-2 text-slate-400 text-xs font-bold">
            <span>PastoreApp Dashboard Engine</span>
            <span className="flex items-center gap-1 text-indigo-600 dark:text-indigo-400">
              Funcionalidades reales en producción <ChevronRight size={14} />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
